export type MetricBorders = {
  time_in_mins: Array<number>;
  co2: Array<number>;
  cost: Array<number>;
  sport: Array<number>;
  distance: Array<number>;
};

export type RelativeMetricBorders = Array<number>;

export enum Metric {
  CO2 = "co2",
  COST = "cost",
  TIME = "time_in_mins",
  SPORT = "sport",
  DISTANCE = "distance",
}
